import { httpRequest } from "../../http";
import { BilledPeriods } from "@models/population.model";

/** Closed billing months that reprocessing this definition would rewrite
 *  (MPN-1516). Same answer as the population endpoint, addressed by definition —
 *  the Files page knows its definition but not its population. */
export class CommandGetDefinitionBilledPeriods {
  async run(definitionId: number): Promise<BilledPeriods> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/billed-periods/`;
    return httpRequest<BilledPeriods>(url, { method: "GET", cache: "no-store" });
  }
}
